import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.optionsBookingSelect.shadow};
`;

export const Items = styled.ul`
  padding: 0;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
`;

export const Item = styled.li`
  font-size: 16px;
  padding: 21px 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.optionsBookingSelect.color};
  border-bottom: 1px solid ${({ theme }) => theme.optionsBookingSelect.line};
  background: ${({ theme }) => theme.optionsBookingSelect.background};

  &.active {
    background-color: ${({ theme }) => theme.optionsBookingSelect.activeBackground};
  }

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: ${ColorPalette.HEX.FloralYellow};
  }
`;
